// Tanggal tanpa jam dari API (kolom DATE) dikirim sebagai "YYYY-MM-DD", tetapi
// beberapa data lama memakai "DD-MM-YYYY". Keduanya diparse ke tengah malam lokal
// agar tidak bergantung pada cara browser (Android/iOS) membaca string tanggal.
export const parseDateOnly = (value?: string | null): Date | null => {
  if (!value) return null;

  const datePart = value.trim().slice(0, 10);
  let match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }

  match = datePart.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (match) {
    return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
  }

  return null;
};

// Contoh: "5 November 2026". Nilai yang tidak bisa diparse dikembalikan apa adanya.
export const formatDateId = (value?: string | null): string => {
  const date = parseDateOnly(value);
  if (!date) return value || "-";

  return date.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

// Selisih hari kalender dari hari ini ke tanggal tersebut (negatif jika sudah lewat).
export const daysFromToday = (value?: string | null): number | null => {
  const date = parseDateOnly(value);
  if (!date) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return Math.round((date.getTime() - today.getTime()) / 86400000);
};
